<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
			<div class="card border-0">
			    <div class="card-header h5 bg-transparent border-0">Edit an Address</div>

          <div v-if="loading == 0" class="card-body">
            <div class="row">
              <div class="col-12 mt-4">
                <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
              </div>
            </div>
          </div>
          <div v-if="loading == 1" class="card-body">

            <div class="row d-flex align-items-center ">
              <div class="col-12">
                <span class="font-weight-bold">Address</span>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-1">
              <div class="col-12 col-lg-2">
                <small>Name</small>
              </div>
              <div class="col-12 col-lg-8">
                <input type="text" class="form-control" placeholder="Location Name, i.e. Central Station, Purchasing Department" v-model="name">
              </div>
            </div>

            <div class="row d-flex align-items-center mb-1">
              <div class="col-12 col-lg-2">
                <small>Address</small>
              </div>
              <div class="col-12 col-lg-8">
                <input type="text" class="form-control" placeholder="Address Line 1" v-model="line1">
              </div>
              <div v-if="showLine2 == 0" class="col-12 col-lg-2">
                <small class="text-primary" @click="toggleAddr2">+ Add Line 2</small>
              </div>
            </div>

            <div v-if="showLine2 == 1" class="row d-flex align-items-center mb-1">
              <div class="col-12 col-lg-2">
                <small>Line 2</small>
              </div>
              <div class="col-12 col-lg-8">
                <input type="text" class="form-control" placeholder="Address Line 2" v-model="line2">
              </div>
              <div class="col-12 col-lg-2">
                <small class="text-danger" @click="toggleAddr2">Remove Line 2</small>
              </div>
            </div>

            <div class="row d-flex align-items-center mb-3">
              <div class="col-12 col-lg-2">
                <small>City, State, Zip</small>
              </div>
              <div class="col-12 col-lg-4">
                <input type="text" class="form-control" placeholder="City" v-model="city">
              </div>
              <div class="col-12 col-lg-3">
                <select class="form-control" v-model="state">
                  <option value='n'>State</option>
                  <option v-for="(state,index) in stateList" :value="state.abbreviation">{{ state.name }}</option>
                </select>
              </div>
              <div class="col-12 col-lg-3">
                <input type="text" class="form-control" placeholder="Zip Code" v-model="zip">
              </div>

            </div>



          </div> <!-- end card body -->
          <div v-if="loading == 1" class="card-body border-top">
            <div class="row d-flex align-items-center mb-3">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <span>
                  <button class="btn btn-warning" @click="cancelUpdate">Cancel</button>
                  <button class="btn btn-success" @click="submitUpdate">Save Changes</button>
                </span>
                <a href="#" @click="resetData">Reset</a>
              </div>
            </div>
          </div><!--  end card-body -->
			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'




export default {
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loading: 0,
      origData: [],
      showLine2: 0,
      name: '',
      line1: '',
      line2: '',
      city: '',
      state: 'n',
      zip: '',
      stateList: [{ "name": "Alabama", "abbreviation": "AL" },
                  { "name": "Alaska", "abbreviation": "AK" },
                  { "name": "American Samoa", "abbreviation": "AS" },
                  { "name": "Arizona", "abbreviation": "AZ" },
                  { "name": "Arkansas", "abbreviation": "AR" },
                  { "name": "California", "abbreviation": "CA" },
                  { "name": "Colorado", "abbreviation": "CO" },
                  { "name": "Connecticut", "abbreviation": "CT" },
                  { "name": "Delaware", "abbreviation": "DE" },
                  { "name": "District Of Columbia", "abbreviation": "DC" },
                  { "name": "Federated States Of Micronesia", "abbreviation": "FM" },
                  { "name": "Florida", "abbreviation": "FL" },
                  { "name": "Georgia", "abbreviation": "GA" },
                  { "name": "Guam", "abbreviation": "GU" },
                  { "name": "Hawaii", "abbreviation": "HI" },
                  { "name": "Idaho", "abbreviation": "ID" },
                  { "name": "Illinois", "abbreviation": "IL" },
                  { "name": "Indiana", "abbreviation": "IN" },
                  { "name": "Iowa", "abbreviation": "IA" },
                  { "name": "Kansas", "abbreviation": "KS" },
                  { "name": "Kentucky", "abbreviation": "KY" },
                  { "name": "Louisiana", "abbreviation": "LA" },
                  { "name": "Maine", "abbreviation": "ME" },
                  { "name": "Marshall Islands", "abbreviation": "MH" },
                  { "name": "Maryland", "abbreviation": "MD" },
                  { "name": "Massachusetts", "abbreviation": "MA" },
                  { "name": "Michigan", "abbreviation": "MI" },
                  { "name": "Minnesota", "abbreviation": "MN" },
                  { "name": "Mississippi", "abbreviation": "MS" },
                  { "name": "Missouri", "abbreviation": "MO" },
                  { "name": "Montana",  "abbreviation": "MT" },
                  { "name": "Nebraska", "abbreviation": "NE" },
                  { "name": "Nevada", "abbreviation": "NV" },
                  { "name": "New Hampshire", "abbreviation": "NH" },
                  { "name": "New Jersey", "abbreviation": "NJ" },
                  { "name": "New Mexico", "abbreviation": "NM" },
                  { "name": "New York", "abbreviation": "NY" },
                  { "name": "North Carolina", "abbreviation": "NC" },
                  { "name": "North Dakota", "abbreviation": "ND" },
                  { "name": "Northern Mariana Islands", "abbreviation": "MP" },
                  { "name": "Ohio", "abbreviation": "OH" },
                  { "name": "Oklahoma", "abbreviation": "OK" },
                  { "name": "Oregon", "abbreviation": "OR" },
                  { "name": "Palau", "abbreviation": "PW" },
                  { "name": "Pennsylvania", "abbreviation": "PA" }, 
                  { "name": "Puerto Rico", "abbreviation": "PR" }, 
                  { "name": "Rhode Island", "abbreviation": "RI" }, 
                  { "name": "South Carolina", "abbreviation": "SC" }, 
                  { "name": "South Dakota", "abbreviation": "SD" }, 
                  { "name": "Tennessee", "abbreviation": "TN" }, 
                  { "name": "Texas", "abbreviation": "TX" }, 
                  { "name": "Utah", "abbreviation": "UT" }, 
                  { "name": "Vermont", "abbreviation": "VT" }, 
                  { "name": "Virgin Islands", "abbreviation": "VI" }, 
                  { "name": "Virginia", "abbreviation": "VA" }, 
                  { "name": "Washington", "abbreviation": "WA" }, 
                  { "name": "West Virginia", "abbreviation": "WV" }, 
                  { "name": "Wisconsin", "abbreviation": "WI" }, 
                  { "name": "Wyoming", "abbreviation": "WY" }],
    }
  },
  computed: {

  },
  watch: {
    
  },
  mounted() {
    this.getAddressInformation();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },

    getAddressInformation() {
      var _this = this;
      _this.loading = 0;
      axios.get('/utility/user/location/getlocationinformation/' + _this.prop3[2] )
        .then(function (response) {
          var a = response.data.data;
          _this.origData = a;
          _this.name = a.name;
          _this.line1 = a.addr1;
          _this.line2 = a.addr2;
          if(a.addr2 != null) {
            _this.showLine2 = 1;
          }
          _this.city = a.city;
          _this.state = a.state;
          _this.zip = a.zip;
          _this.loading = 1;
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },
  
    resetData() {
      var _this = this;
      _this.name = _this.origData.name;
      _this.line1 = _this.origData.addr1;
      _this.line2 = _this.origData.addr2;
      if(_this.origData.addr2 != null) {
        _this.showLine2 = 1;
      } else {
        _this.showLine2 = 0;
      }
      _this.city = _this.origData.city;
      _this.state = _this.origData.state;
      _this.zip = _this.origData.zip;
    },

    toggleAddr2() {
      var _this = this;
      if(_this.showLine2 == 1) {
        _this.line2 = '';
        _this.showLine2 = 0;
      } else {
        _this.showLine2 = 1;
      }
    },

    submitUpdate() {
      var _this = this;
      _this.$toastr.warning('Validating address information.', 'Please wait!')
      //validate with js
      var valErrors = [];
      
      //validate addresses

      if(_this.name == '' || _this.name == null) { valErrors.push('An address requires an address name.') }
      if(_this.line1 == '' || _this.line1 == null || _this.line1.length < 3) { valErrors.push('An address requires a valid address.') }
      if(_this.city == '' || _this.city == null || _this.city.length < 3) { valErrors.push('An address requires a valid city.') }
      if(_this.state == '' || _this.state == null || _this.state == 'n' ) { valErrors.push('An address requires a valid state.') }
      var zipFormat = /^\d{5}(-\d{4})?$/;  
      if(_this.zip == '' || _this.zip == null) { valErrors.push('An address requires an zip code.') }
      if(!_this.zip.match(zipFormat)) { valErrors.push("The zip code you entered is invalid. It must be numeric and in the format XXXXX or XXXXX-XXXX") }  


      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove();
      
      _this.$toastr.warning('Saving address information.', 'Please wait!')
      axios.post('/utility/user/location/updatelocation', {
        loc_id: _this.prop3[2],
        name: _this.name,
        line1: _this.line1,
        line2: _this.line2,
        city: _this.city,
        state: _this.state,
        zip: _this.zip

      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', [ 'address-edit' ])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },

    cancelUpdate() {
      var _this = this;
      _this.$emit('onUComplete', ['address-edit'])
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>

